
const plain = (t) => String(t || "").replace(/\[([^\]]+)\]\([^)]+\)/g, "$1").replace(/[*_`#>]+/g, "");

export const RelocHistory = ({ g }) => (
  <div data-testid="reloc-history">
    <div>
      <p className="eyebrow mb-4">Official fee updates · {g.fee_history.length}</p>
      <div className="max-h-[480px] overflow-auto border border-[#E2D9CC] bg-[#FAF7F2]">
        {g.fee_history.map((f) => (
          <div key={f.id} className="px-4 py-3 border-b border-[#E2D9CC] last:border-0 text-xs">
            <p className="text-[#3B1B48]">Chapter {f.chapter} · {f.fee} <span className="text-[#8C827A]">· {new Date(f.ts).toLocaleDateString("en-AU")}</span></p>
            <p className="text-[#8C827A] line-through mt-1 line-clamp-2">{plain(f.old)}</p>
            <p className="mt-0.5 line-clamp-2">{plain(f.new)}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const RelocSources = ({ g }) => (
  <div className="grid md:grid-cols-2 gap-x-10" data-testid="reloc-sources">
    {g.sources.map((s, i) => (
      <a key={`${s.url}-${i}`} href={s.url} target="_blank" rel="noreferrer" className="block py-3 border-b border-[#E2D9CC] hover:bg-[#EFE6F3]/60 transition-colors text-sm">
        <span className="text-[#3B1B48]">{s.name}</span><span className="block text-xs text-[#8C827A] break-all">{s.url}</span>
      </a>
    ))}
  </div>
);
